<template>
  <div class="users-notes-container scroll-list-wrap">
    <div class="content list-wrapper" ref="wrapper">
      <div class="content-word">
        <div v-for="(item,index) in statementArr" :key="index" class="item-box" @click="toLinkHandle(item.link)">{{item.text}}</div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="confirm"  class="confirm-btn">{{$t('home.dialogTexts.confirmandread')}}</el-button>
      <el-button @click="returnLogin" class="back-btn">{{$t('home.dialogTexts.returnLogin')}}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    idType: {
      type: String,
      default: 'CHINA_IDENTITY_CARD'
    }
  },
  data () {
    return {
      // statementArr: this.$t('common.statementArr')
    }
  },
  computed: {
    statementArr() {
      if (this.idType === 'CHINA_IDENTITY_CARD') {
        return this.$t('common.statementArr')
      } else {
        let arr = this.$t('common.statementArr')
        return this.$t('common.statementArr').slice(0, arr.length - 1)
      }
    }
  },
  methods: {
    returnLogin () {
      this.$emit('returnLogin')
    },
    confirm () {
      this.$emit('confirm', false)
    },
    toLinkHandle(val) {
      window.open(val)
    }

  }
}
</script>

<style lang="scss">
  .users-notes-container{
  background-color: white;
  // height: 400px;
  width: 100%;
  margin: auto;
  text-align: center;
  .item-box{
    border-bottom: 1px solid #EEEEEE;
    cursor: pointer;
  }
  .content{
    .content-word{
      width: 100%;
      line-height: 46px;
      color: #3773E1;
      font-size: 14px;
      text-align: center;
      font-family: PingFangSC-Regular;
      margin: auto;
      .agree-check{
        color: rgba(85, 85, 85, 1);
        font-size: 30px;
        text-align: center;
        font-family: PingFangSC-Regular;
      }
    }
  }
  .dialog-footer{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 30px;
    .el-button {
      height: 50px !important;
      border-radius: 4px !important;
      color: #193060;
      font-size: 14px;
      text-align: center;
    }
    .back-btn{
      width: 80% !important;
      margin-left: 0;
      border: 1px solid #193060;
    }
    .confirm-btn{
      width: 80% !important;
      margin-bottom: 20px;
      color: #001e50;
    }
  }
}

</style>
